/**
 * @Author: DJ
 * @Date:   2021-07-09 15:03:56
 * @Last Modified by:   DJ
 * @Last Modified time: 2021-09-07 09:28:25
 */
 import React from 'react';
 import { Button } from 'antd';
 import {Link} from 'react-router-dom';
 import styles from './index.module.scss';
 
 const Index = (props) => {
     // eslint-disable-next-line react/prop-types
    //  const { failCount, successCount, failReason } = props;
   return (
     <div className={styles.loading}>
       <div className={styles.loadingPng}></div>
       <div className={styles.loadingTitle}>上传完成</div>
       {/* <div className={styles.titleMean}>
        成功导入<span>{successCount?successCount:0}</span>条，失败<span>{failCount?failCount:0}</span>条
       </div>
       <div className={styles.btn}>
         <Link to={'/home/order/preorder'}>
         <Button className={styles.bt1} >查看导入成功订单</Button>
         </Link>
           
           <Button disabled={failCount===0} className={styles.bt2} onClick={failReason}>下载导入失败原因</Button>
       </div> */}
     </div>
   );
 };

 export default Index;
 